import { render, staticRenderFns } from "./FileAttachmentPreview.vue?vue&type=template&id=c8d4515e&scoped=true"
import script from "./FileAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./FileAttachmentPreview.vue?vue&type=script&lang=js"
import style0 from "./FileAttachmentPreview.vue?vue&type=style&index=0&id=c8d4515e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d4515e",
  null
  
)

export default component.exports